import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import museumsData from "./museumsData";
const Museums = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Museums",
      breadcrumb: {
        home: "HOME",
        page: "MUSEUMS",
      },
      divisionLabel: "Museums",
      p: "The museums undertake very important job of conserving, preserving and showcasing the heritage of India to the next generation. The Directorate has 13 museums under its jurisdiction that are home to artefacts unearthed during excavations and or those found during explorations. They also house important historical objects, weapons and weaves, clothes and dresses, sculptures and art objects, artworks, inscriptions, structural members of the ancient- mediaeval period, paintings of revered artists etc. The main aim and objective of these museums is to not only display them for delight but also as educative devices.",
      p1: "The Directorate of Archaeology and Museums currently has 13 museums under its jurisdiction.",
      p2: "Apart from the aforementioned museums, the Directorate of Archaeology and Museums is in the process of establishing a new museum at the Lakshmi Vilas Palace in Kolhapur.",
      p3: "In order to document the museums in the State of Maharashtra, the Directorate undertook a special drive in the year 2022-2023. This special drive revealed nearly 200 museums and private collections in the State of Maharashtra. These sheer number of these museums and their collection is a testimony to the rich culture and past of Maharashtra.",
    },
    मराठी: {
      title: "संग्रहालये",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "संग्रहालये",
      },
      divisionLabel: "वस्तुसंग्रहालये",
      p:"ही संग्रहालये भारताच्या वारशाचे जतन, जतन आणि पुढील पिढीला दाखवण्याचे अत्यंत महत्त्वाचे काम करतात. संचालनालयाच्या अखत्यारीत १३ संग्रहालये आहेत जी उत्खननादरम्यान सापडलेल्या आणि किंवा शोध दरम्यान सापडलेल्या कलाकृतींचे घर आहेत. त्यामध्ये महत्त्वाच्या ऐतिहासिक वस्तू, शस्त्रे आणि विणकाम, कपडे आणि पोशाख, शिल्पे आणि कला वस्तू, कलाकृती, शिलालेख, प्राचीन-मध्ययुगीन काळातील संरचनात्मक घटक, आदरणीय कलाकारांची चित्रे इत्यादी देखील आहेत. या संग्रहालयांचे मुख्य उद्दिष्ट आणि उद्दिष्ट केवळ आनंदासाठीच नाही तर शैक्षणिक उपकरणे म्हणून देखील प्रदर्शित करणे आहे",
      p1:"पुरातत्व आणि संग्रहालये संचालनालयाच्या अखत्यारीत सध्या १३ संग्रहालये आहेत.",
      p2:"वर उल्लेख केलेल्या संग्रहालयांव्यतिरिक्त, पुरातत्व आणि संग्रहालये संचालनालय कोल्हापूरमधील लक्ष्मी विलास पॅलेसमध्ये एक नवीन संग्रहालय स्थापन करण्याच्या प्रक्रियेत आहे.",
      p3:"महाराष्ट्र राज्यातील संग्रहालयांचे दस्तऐवजीकरण करण्यासाठी, संचालनालयाने २०२२-२०२३ मध्ये एक विशेष मोहीम हाती घेतली. या विशेष मोहिमेत महाराष्ट्र राज्यातील सुमारे २०० संग्रहालये आणि खाजगी संग्रह उघड झाले. या संग्रहालयांची ही असंख्य संख्या आणि त्यांचा संग्रह महाराष्ट्राच्या समृद्ध संस्कृती आणि भूतकाळाची साक्ष देतो",
    },
  };

  const t = content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Heading */}
      <div className="text-center">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Content */}
      <div className="px-4 md:px-10 max-w-7xl mx-auto mt-16">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          {/* Sidebar */}
          <div className="bg-[#F6F6EC] rounded-2xl border-[1px] border-[#F8D6BF] p-4 md:w-1/2 lg:w-1/3 w-full mt-0">
            <h2 className="text-left ml-2 text-[14px] sm:text-lg md:text-xl lg:text-[26px] font-semibold pt-2 pb-3">
              {t.divisionLabel}
            </h2>
            <ul className="space-y-1 no-dark-bg text-start">
              {museumsData.map((museum) => {
                const content = museum.content[selectedLang];
                return (
                  <Link
                    key={museum.id}
                    to={`/museums/${museum.id}`}
                    className="link-btn w-full flex justify-between items-center text-gray-800 bg-[#EFEDE0] px-3 py-2 rounded-md cursor-pointer hover:bg-[#FB9C00] hover:text-white transition font-futura"
                  >
                    <span>
                      {content.title}
                    </span>
                  </Link>
                );
              })}
            </ul>
          </div>
          {/* Map Area */}
          <div className="w-full md:w-1/2 lg:w-2/3 text-justify space-y-5 font-futura">
            <p className="text-[14px] sm:text-lg md:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
              {t.p}
            </p>
            <p className="text-[14px] sm:text-lg md:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
              {t.p1}
            </p>
            <p className="text-[14px] sm:text-lg md:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
              {t.p2}
            </p>
            <p className="text-[14px] sm:text-lg md:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
              {t.p3}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Museums;
